import type { ITableLikeTreeFilterItem, ITableLikeTreeItem } from 'components/TableLikeTree/context';

const objectOneOneOne = {
    id: 4,
    title: '2021 Группа 1: Объект 1.1.1',
    children: [],
    column1: '1 1.1.1',
    column2: '2 1.1.1',
    groupId: 1,
    year: 2021,
};

const objectOneOneTwo = {
    id: 3,
    title: '2021 Группа 1: Объект 1.1.2',
    children: [],
    column1: '1 1.1.2',
    column2: '2 1.1.2',
    groupId: 1,
    year: 2021,
};

const objectOneOne = {
    id: 2,
    title: '2021 Группа 1: Объект 1.1',
    children: [objectOneOneOne, objectOneOneTwo],
    column1: '1 1.1',
    column2: '2 1.1',
    groupId: 1,
    year: 2021,
};

const objectOne = {
    id: 1,
    title: '2021 Группа 1: Объект 1',
    children: [objectOneOne],
    column1: '1 1',
    column2: '2 1',
    groupId: 1,
    year: 2021,
};

const objectTwoOneOne = {
    id: 7,
    title: '2021 Группа 2: Объект 2.1.1',
    children: [],
    column1: '1 2.1.1',
    column2: '2 2.1.1',
    groupId: 2,
    year: 2021,
};

const objectTwoOneTwo = {
    id: 8,
    title: '2021 Группа 2: Объект 2.1.2',
    children: [],
    column1: '1 2.1.2',
    column2: '2 2.1.2',
    groupId: 2,
    year: 2021,
};

const objectTwoOneThree = {
    id: 9,
    title: '2021 Группа 2: Объект 2.1.3',
    children: [],
    column1: '1 2.1.3',
    column2: '2 2.1.3',
    groupId: 2,
    year: 2021,
};

const objectTwoOne = {
    id: 6,
    title: '2021  Группа 2: Объект 2.1',
    children: [objectTwoOneOne, objectTwoOneTwo, objectTwoOneThree],
    column1: '1 2.1',
    column2: '2 2.1',
    groupId: 2,
    year: 2021,
};

const objectTwo = {
    id: 5,
    title: '2021 Группа 2: Объект 2',
    children: [objectTwoOne],
    column1: '1 2',
    column2: '2 2',
    groupId: 2,
    year: 2021,
};

const objectThreeOne = {
    id: 11,
    title: '2022 Группа 2: Объект 3.1',
    children: [],
    column1: '1 2',
    column2: '2 2',
    groupId: 2,
    year: 2022,
};

const objectThree = {
    id: 10,
    title: '2022 Группа 2: Объект 3',
    children: [objectThreeOne],
    column1: '1 2',
    column2: '2 2',
    groupId: 2,
    year: 2022,
};

export const tableLikeTreeMockItems: ITableLikeTreeItem[] = [objectOne, objectTwo, objectThree];

export const tableLikeTreeLeftFilterMockItems: ITableLikeTreeFilterItem[] = [
    {
        id: 1,
        title: 'Группа 1',
    },
    {
        id: 2,
        title: 'Группа 2',
    },
];

export const tableLikeTreeTopFilterMockItems: ITableLikeTreeFilterItem[] = [
    {
        id: 2021,
        title: '2021',
    },
    {
        id: 2022,
        title: '2022',
    },
    {
        id: 2023,
        title: '2023',
    },
];
